import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";

const ModalBox = ({
  status,
  onClose,
  title,
  description,
  autoClose = false,
  size,
  closeIcon = false,
}) => {
  useEffect(() => {
    if (autoClose && status) {
      const timer = setTimeout(() => {
        onClose();
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [autoClose, status, onClose]);

  return (
    <Dialog
      open={status}
      onClose={(e, reason) => {
        if (reason !== "backdropClick") onClose();
      }}
      fullWidth
      maxWidth={size || "xs"}
      PaperProps={{
        className: "rounded-2xl shadow-lg",
        style: { overflow: "hidden" },
      }}
    >
      {/* Title with optional close icon */}
      <DialogTitle
        align="center"
        sx={{
          fontWeight: 600,
          fontSize: "1.25rem",
          background: "linear-gradient(90deg, #8f0303, #fc8c03)",
          color: "white",
          py: 1.5,
          position: "relative",
        }}
      >
        {title}
        {closeIcon && (
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 10,
              top: 8,
              color: "white",
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          py: 4,
        }}
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          className="text-center"
        >
          {description}
        </motion.div>
        
      </DialogContent>
    </Dialog>
  );
};

export default ModalBox;
